export default __webpack_public_path__ + "static/media/song5_img.06875db0.jpg";